import { IconButton, makeStyles } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.gray[800],
    padding: 0,
    marginRight: theme.spacing(1),
    width: 32,
    height: 32,
  },
}));

export const BackButton = ({ onClick, ...props }) => {
  const classes = useStyles();
  return (
    <IconButton {...props} classes={classes} size="small" onClick={onClick}>
      <ArrowBackIosIcon
        style={{ fontSize: "0.9rem", position: "relative", left: "0.2rem" }}
      />
    </IconButton>
  );
};
